export const CATEGORY_COLORS: Record<string, string> = {
  academic: 'bg-brand-teal-50 text-brand-teal-600 border-brand-teal-100',
  behavioral: 'bg-brand-amber-50 text-brand-amber-500 border-brand-amber-100',
  services: 'bg-brand-teal-50 text-brand-teal-600 border-brand-teal-100',
  placement: 'bg-brand-slate-50 text-brand-slate-600 border-brand-slate-200',
};
